<template>
  <div id="application" class="">
    <header id="header" class="columns is-mobile mb-0">
      <div class="column is-half has-text-left">
        <a href="">
          <img
              src="../assets/img/istobal-logo.png"
              :alt="$t('general.istobal-logo')"
          >
        </a>
      </div>
      <div class="column is-4 is-offset-2 has-text-right">
        <b-dropdown
            v-model="$i18n.locale"
            position="is-bottom-right"
            append-to-body
            aria-role="list">
          <template #trigger>
            <a
                class="navbar-item language pr-0"
                role="button">
              <b-icon
                  pack="fas"
                  icon="globe"
                  size="is-small">
              </b-icon>
              <span class="lang">{{ $i18n.locale.toUpperCase() }}</span>
            </a>
          </template>
          <b-dropdown-item aria-role="listitem" v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">
            {{ lang.toUpperCase() }}
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </header>
    <!--<b-navbar
      active
      mobile-burger=false
      fixed-top=true
      >
      <template #start>-->
    <section id="configurador" class="columns is-vcentered is-mobile is-multiline" v-bind:class="{ fijo: fijarPuente }">
      <div class="column is-full c1">
        <div class="columns is-vcentered is-mobile is-multiline m-0">
          <div id="menu-mobile" class="column is-10 pr-0 has-text-centered">
            <b-button
                class="has-text-weight-bold pt-0 maquina-seleccionada"
                @click="cambiaModalSelPuentes(true)">
              {{ this.puentelavadoactivo.nombre.es }}
              <b-icon
                  pack="fas"
                  icon="sort-down"
                  size="is-medium"
                  class="ml-1">
              </b-icon>
            </b-button>
          </div>
          <div class="info column is-2   has-text-right">
            <i class="material-icons" @click="isComponentModalActive = true">&#xe88f;</i>
            <b-modal
                v-model="isComponentModalActive"
                trap-focus
                :destroy-on-hide="false"
                aria-role="dialog"
                aria-label="Example Modal"
                aria-modal
                custom-class="info-puente">
              <div class="card px-6 pb-6">
                <div class="card-content has-text-left pt-0">
                  <div class="content pb-2">
                    <h1 class="is-size-5">ISTOBAL M'START</h1>
                    <p>La eficiencia en el lavado es algo más que un concepto, es el resultado de aunar calidad,
                      tecnología y rendimiento en un único diseño.</p>
                    <p>Así es <strong>ISTOBAL M’START</strong>, el puente de lavado desarrollado por
                      <strong>ISTOBAL</strong> que satisface las expectativas de cualquier cliente.</p>
                  </div>
                </div>
              </div>
            </b-modal>
          </div>
        </div>
      </div>
      <div id="puente-configurado" class="column is-full p-0">
        <b-carousel
            :interval=6000
            repeat
            has-drag
            animated="slide"
            :autoplay=false
        >
          <b-carousel-item>
            <div class="hero">
              <div class="hero-body p-0 has-text-centered">
                <img
                    src="../assets/img/M1_frontal-maquetacion.jpg"
                    alt="M1 Front"
                >
              </div>
            </div>
          </b-carousel-item>
          <b-carousel-item>
            <div class="hero">
              <div class="hero-body p-0 has-text-centered">
                <img
                    src="../assets/img/M1_trasera-maquetacion.jpg"
                    alt="M1 Front"
                >
              </div>
            </div>
          </b-carousel-item>
        </b-carousel>
      </div>
    </section>
    <!--</template>
  </b-navbar>-->
    <section id="configurador-2" class="columns is-vcentered is-mobile is-multiline">
      <div id="elementos-configurables" class="column is-full px-0">
        <div class="menu">
          <div class="scrolling-wrapper">
            <div class="opcion viewed">
              <b-button>Estructura</b-button>
            </div>
            <div class="opcion viewed">
              <b-button>Carenado</b-button>
            </div>
            <div class="opcion">
              <b-button disabled>Cabuts</b-button>
            </div>
            <div class="opcion">
              <b-button>Puertas</b-button>
            </div>
            <div class="opcion">
              <b-button>Cepillos</b-button>
            </div>
            <div class="opcion">
              <b-button>Lavarruedas</b-button>
            </div>
            <div class="opcion selected">
              <b-button>Luminosos</b-button>
            </div>
            <div class="opcion">
              <b-button>Pictogramas</b-button>
            </div>
          </div>
        </div>
        <div class="detalles column is-full px-0">
          <div id="estructura" class="tab-detalle has-text-left is-hidden">
            <h3 class="has-text-weight-bold is-red is-uppercase">Estructura</h3>
            <p class="is-size-6 mt-2">Haga click para seleccionar el color</p>
            <div class="colores has-text-left">
              <b-button type="is-RAL9016" @click="isColoresCarenadoModalActive = true">RAL9016</b-button>
              <p @click="isColoresCarenadoModalActive = true">RAL9016</p>
            </div>
          </div>
          <div id="carenado" class="tab-detalle has-text-left">
            <h3 class="has-text-weight-bold is-red is-uppercase">Carenado</h3>
            <div class="scrolling-wrapper">
              <div class="opcion">
                <b-button>Plano</b-button>
              </div>
              <div class="opcion selected">
                <b-button>Rocket</b-button>
              </div>
            </div>
            <p class="is-size-6 mt-2">Haga click para seleccionar el color</p>
            <div class="colores has-text-left">
              <b-button type="is-RAL9016" @click="isColoresCarenadoModalActive = true">RAL9016</b-button>
              <p @click="isColoresCarenadoModalActive = true">RAL9016</p>
            </div>
          </div>
          <div id="cabuts" class="tab-detalle has-text-left is-hidden">
            <h3 class="has-text-weight-bold is-red is-uppercase">Cabuts</h3>
            <div class="scrolling-wrapper">
              <div class="opcion selected">
                <b-button>Rocket</b-button>
              </div>
            </div>
            <p class="is-size-6 mt-2">Haga click para seleccionar el color</p>
            <div class="colores has-text-left">
              <b-button type="is-RAL9016" @click="isColoresCarenadoModalActive = true">RAL9016</b-button>
              <p @click="isColoresCarenadoModalActive = true">RAL9016</p>
            </div>
          </div>
          <div id="puertas" class="tab-detalle has-text-left is-hidden">
            <h3 class="has-text-weight-bold is-red is-uppercase">Puertas</h3>
            <div class="scrolling-wrapper">
              <div class="opcion selected">
                <b-button>Rocket</b-button>
              </div>
            </div>
            <p class="is-size-6 mt-2">Haga click para seleccionar el color</p>
            <div class="colores has-text-left">
              <b-button type="is-RAL9016" @click="isColoresCarenadoModalActive = true">RAL9016</b-button>
              <p @click="isColoresCarenadoModalActive = true">RAL9016</p>
            </div>
          </div>
          <div id="lavarruedas" class="tab-detalle has-text-left is-hidden">
            <h3 class="has-text-weight-bold is-red is-uppercase">Lavaruedas</h3>
            <b-field>
              <b-switch v-model="incluirLavarruedas"
                        true-value="Sí"
                        false-value="No"
                        type="is-primary">
                {{ incluirLavarruedas }}
              </b-switch>
            </b-field>
          </div>
          <div id="luminosos" class="tab-detalle has-text-left is-hidden">
            <h3 class="has-text-weight-bold is-red is-uppercase">
              Luminosos
              <b-field>
                <b-switch v-model="luminosoIncluir"
                          true-value="Sí"
                          false-value="No"
                          type="is-primary">
                  {{ luminosoIncluir }}
                </b-switch>
              </b-field>
            </h3>
            <b-field>
              <b-radio v-model="luminoso"
                       native-value="Semaforo"
                       type="is-primary"
                       disabled>
                Semáforo
              </b-radio>
            </b-field>
            <b-field>
              <b-radio v-model="luminoso"
                       native-value="Sferic"
                       type="is-primary"
                       disabled>
                Semáforo + Sferic
              </b-radio>
            </b-field>
          </div>
          <div id="pictogramas" class="tab-detalle has-text-left is-hidden">
            <h3 class="has-text-weight-bold is-red is-uppercase">Pictogramas</h3>
            <b-field>
              <b-radio v-model="pictograma"
                       native-value="No"
                       type="is-primary">
                No
              </b-radio>
            </b-field>
            <b-field>
              <b-radio v-model="pictograma"
                       native-value="Silver"
                       type="is-primary">
                Silver
              </b-radio>
            </b-field>
            <b-field>
              <b-radio v-model="pictograma"
                       native-value="Hexa"
                       type="is-primary">
                Hexa
              </b-radio>
            </b-field>
          </div>
          <div id="cepillos" class="tab-detalle has-text-left is-hidden">
            <h3 class="has-text-weight-bold is-red is-uppercase">Cepillos</h3>
            <div class="scrolling-wrapper">
              <div class="opcion">
                <b-button>Liso</b-button>
              </div>
              <div class="opcion">
                <b-button>Bandas</b-button>
              </div>
              <div class="opcion selected">
                <b-button>Rayado</b-button>
              </div>
            </div>
            <p class="is-size-6 mt-2">Haga click para seleccionar el color</p>
            <div class="colores has-text-left">
              <b-button type="is-R06" @click="isColoresCepillosModalActive = true">R06</b-button>
              <b-button type="is-R06">R06</b-button>
              <b-button type="is-GR1">GR1</b-button>
              <b-button type="is-GR1">GR1</b-button>
              <b-button type="is-R06">R06</b-button>
              <b-button type="is-R06">R06</b-button>
              <b-button type="is-R06">R06</b-button>
              <b-button type="is-R06">R06</b-button>
              <b-button type="is-R06">R06</b-button>
              <b-button type="is-R06">R06</b-button>
              <b-button type="is-R06">R06</b-button>
              <b-button type="is-R06">R06</b-button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div id="compartir" class="section" v-bind:class="{ fijo: fijarBotonesFooter }">
      <div class="columns is-vcentered is-mobile is-multiline">
        <div class="column is-half">
          <b-button type="is-rojo"
                    size="is-medium"
                    icon-left="share-variant"
                    expanded
                    @click="isCompartirModalActive = true">
            Compartir
          </b-button>
        </div>
        <div class="column is-half">
          <b-button type="is-verde"
                    size="is-medium"
                    icon-left="email-outline"
                    expanded
                    @click="isAyudaModalActive = true">
            Contactar
          </b-button>
        </div>
      </div>
    </div>
    <footer class="footer pb-0 mt-5" v-bind:class="{ conPadding: fijarBotonesFooter }"
            v-observe-visibility="visibilityChanged">
      <div class="content has-text-centered">
        <p class="is-size-6">
          <img
              class="logo"
              src="../assets/img/ISTOBAL_Vehicle-Wash-and-Care_b.png"
              alt="ISTOBAL - Vehicle Wash & Care"
          ><br/>
          Las imágenes, videos e informaciones que aparecen en este espacio son meramente ilustrativos y no vinculantes,
          pueden ser opcionales o no estar disponibles según el modelo, y no constituyen una oferta. Puede contactar con
          el departamento comercial de ISTOBAL para cualquier información adicional o solicitud de oferta de nuestros
          productos.
        </p>
        <p class="copyright is-size-6">© ISTOBAL 2021. Todos los derechos reservados.</p>
      </div>
    </footer>
    <b-modal
        v-model="isColoresCepillosModalActive"
        trap-focus
        :destroy-on-hide="false"
        aria-role="dialog"
        aria-label="Selector de colores"
        aria-modal
        custom-class="selector-colores">
      <div class="card">
        <div class="card-content has-text-centered">
          <div class="content pb-2">
            <h4 class="is-size-5 has-text-weight-normal is-gris">Seleccionar color</h4>
            <a class="close has-text-right is-size-7">
              <span class="has-text-centered"><img svg-inline class="icon" src="../assets/img/icon-close.svg"
                                                   alt="cerrar"/></span>
            </a>
            <div class="colores has-text-centered">
              <b-button type="is-R06">R06</b-button>
              <b-button type="is-AZL">AZL</b-button>
              <b-button type="is-AZ2">AZ2</b-button>
              <b-button type="is-AZ3">AZ3</b-button>
              <b-button type="is-AZJ">AZJ</b-button>
              <b-button type="is-VE1">VE1</b-button>
              <b-button type="is-VE2">VE2</b-button>
              <b-button type="is-VE3">VE3</b-button>
              <b-button type="is-VE4">VE4</b-button>
              <b-button type="is-NA1" focused>NA1</b-button>
              <b-button type="is-AM5">AM5</b-button>
              <b-button type="is-GR1">GR1</b-button>
              <b-button type="is-GR7">GR7</b-button>
              <b-button type="is-BL1">BL1</b-button>
              <b-button type="is-MA1">MA1</b-button>
              <b-button type="is-VI2">VI2</b-button>
              <b-button type="is-NE1">NE1</b-button>
            </div>
            <b-button type="is-ghost" expanded class="py-4 is-size-5" @click="isColoresCepillosModalActive = false">
              Cancelar
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
        v-model="isColoresCarenadoModalActive"
        trap-focus
        :destroy-on-hide="false"
        aria-role="dialog"
        aria-label="Selector de colores"
        aria-modal
        custom-class="selector-colores">
      <div class="card">
        <div class="card-content has-text-centered">
          <div class="content pb-2">
            <h4 class="is-size-5 has-text-weight-normal is-gris">Seleccionar color</h4>
            <!--<a class="close has-text-right is-size-7">
              <span class="has-text-centered"><img svg-inline class="icon" src="../assets/img/icon-close.svg" alt="cerrar" /></span>
            </a>-->
            <div class="colores has-text-centered">
              <b-button type="is-RAL9016" focused>RAL9016</b-button>
              <b-button type="is-RAL9010">RAL9010</b-button>
              <b-button type="is-RAL9003">RAL9003</b-button>
              <b-button type="is-RAL9018">RAL9018</b-button>
              <b-button type="is-RAL1013">RAL1013</b-button>
              <b-button type="is-RAL1021">RAL1021</b-button>
              <b-button type="is-RAL1003">RAL1003</b-button>
              <b-button type="is-RAL1033">RAL1033</b-button>
              <b-button type="is-LAVANCE">LAVANCE</b-button>
              <b-button type="is-RAL2004">RAL2004</b-button>
              <b-button type="is-RAL3020">RAL3020</b-button>
              <b-button type="is-RAL3002">RAL3002</b-button>
              <b-button type="is-RAL5004">RAL5004</b-button>
              <b-button type="is-RAL5011">RAL5011</b-button>
              <b-button type="is-P280C">P280C</b-button>
              <b-button type="is-P293C">P293C</b-button>
              <b-button type="is-RAL5015">RAL5015</b-button>
              <b-button type="is-P7468C">P7468C</b-button>
              <b-button type="is-P299C">P299C</b-button>
              <b-button type="is-P348C">P348C</b-button>
              <b-button type="is-P368C">P368C</b-button>
              <b-button type="is-COOLGRAY1">COOLGRAY1</b-button>
              <b-button type="is-RAL7035">RAL7035</b-button>
              <b-button type="is-RAL7032">RAL7032</b-button>
              <b-button type="is-RAL9006">RAL9006</b-button>
              <b-button type="is-RAL7040">RAL7040</b-button>
              <b-button type="is-P424C">P424C</b-button>
              <b-button type="is-GRISSHELL">GRISSHELL</b-button>
              <b-button type="is-RAL7022">RAL7022</b-button>
              <b-button type="is-RAL9005">RAL9005</b-button>
            </div>
            <b-button type="is-ghost" expanded class="py-4 is-size-5" @click="isColoresCarenadoModalActive = false">
              Cancelar
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
        v-model="isCompartirModalActive"
        trap-focus
        :destroy-on-hide="false"
        aria-role="dialog"
        aria-label="Compartir"
        aria-modal
        custom-class="modal-compartir">
      <div class="card">
        <div class="card-content has-text-centered">
          <div class="content pb-2">
            <h4 class="is-size-5 has-text-weight-normal is-gris">Compartir</h4>
            <!--<a class="close has-text-right is-size-7">
              <span class="has-text-centered"><img svg-inline class="icon" src="../assets/img/icon-close.svg" alt="cerrar" /></span>
            </a>-->
            <div class="colores compartir has-text-left">
              <b-menu>
                <b-menu-list>
                  <b-menu-item icon="email-outline" label="E-mail"></b-menu-item>
                  <b-menu-item icon="file-pdf-outline" label="Descargar PDF"></b-menu-item>
                  <b-menu-item icon="content-copy" label="Copiar enlace"></b-menu-item>
                </b-menu-list>
              </b-menu>
            </div>
            <b-button type="is-ghost" expanded class="py-4 is-size-5" @click="isCompartirModalActive = false">Cancelar
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
        v-model="isAyudaModalActive"
        trap-focus
        :destroy-on-hide="false"
        aria-role="dialog"
        aria-label="Compartir"
        aria-modal
        custom-class="modal-ayuda">
      <div class="card">
        <div class="card-content has-text-centered">
          <div class="content ayuda pb-2">
            <h4 class="is-size-5 has-text-weight-normal is-gris mt-1 mb-5">
              <img
                  src="../assets/img/istobal-logo.png"
                  :alt="$t('general.istobal-logo')"
              >
            </h4>
            <p class="mb-5"><strong>¿Necesitas ayuda?</strong> Contáctanos y uno de nuestros profesionales te asesorará
            </p>
            <b-button type="is-ghost" expanded class="py-4 is-size-5" @click="llamar()">Llamar +34 96 111 10 20
            </b-button>
            <b-button type="is-ghost" expanded class="py-4 is-size-5"
                      @click="isCompartirModalActive = false;isContactoModalActive = false">Solicitar más información
            </b-button>
            <b-button type="is-ghost" expanded class="salir py-4 is-size-5" @click="isAyudaModalActive = false">Salir
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
        v-model="isPrevenirSalidaModalActive"
        trap-focus
        :destroy-on-hide="false"
        aria-role="dialog"
        aria-label="Seguro"
        aria-modal
        custom-class="modal-ayuda">
      <div class="card">
        <div class="card-content has-text-centered">
          <div class="content ayuda prevenir pb-2">
            <h4 class="is-size-5 has-text-weight-normal is-gris mt-1 mb-5">
              <img
                  src="../assets/img/istobal-logo.png"
                  :alt="$t('general.istobal-logo')"
              >
            </h4>
            <p class="mb-5">Seleccione qué prefiere hacer con el puente de lavado que ha configurado</p>
            <b-button type="is-ghost" expanded class="py-4 is-size-5"
                      @click="isPrevenirSalidaModalActive = false;isCompartirModalActive = true">Compartir o guardar
            </b-button>
            <b-button type="is-ghost" expanded class="py-4 is-size-5"
                      @click="isPrevenirSalidaModalActive = false;isContactoModalActive = true">Solicitar más
              información
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
        v-model="isMenuModalActive"
        trap-focus
        :destroy-on-hide="false"
        aria-role="dialog"
        aria-label="Menú"
        aria-modal

        custom-class="puentes-disponibles">
      <lista-puentes></lista-puentes>

    </b-modal>
  </div>
</template>

<script>
import ListaPuentes from "../components/listaPuentes";
export default {
  name: "Static",
  components: {ListaPuentes},
  data() {
    return {

      puentedefault: {
        sku: 'Test',
        nombre: {
          'es': "M'NEXT",
          'en': "M'NEXT",
        },
        "nombre-completo": {
          'es': "ISTOBAL M'MNEXT ES",
          'en': "ISTOBAL M'MNEXT EN",
        },
      },
      isComponentModalActive: false,
      isColoresCepillosModalActive: false,
      isColoresCarenadoModalActive: false,
      isCompartirModalActive: false,
      isAyudaModalActive: false,
      isContactoModalActive: false,
      isPrevenirSalidaModalActive: false,
      incluirLavarruedas: 'Sí',
      luminosoIncluir: 'No',
      luminoso: 'Sferic',
      pictograma: 'Silver',
      langs: ['es', 'en'],
      fijarBotonesFooter: false,
      scrollDirection: null,
      scrollYPosition: 0,
      fijarPuente: false
    }
  },
  computed: {
    isMenuModalActive: {
      get() {
        return this.$store.getters.getIsMenuModalActive
      },
      set(value) {
        this.$store.commit('setIsMenuModalActive', value)
      }
    },
    puentelavadoactivo: function() {
      if (this.$store.getters.getPuenteLavadoActivo !== null){
        return this.$store.getters.getPuenteLavadoActivo
      }else{
        return this.puentedefault
      }
    },
    skuactivo: function() {
      return this.$store.getters.getSKUActivo
    }


  },
  mounted: function () {
    window.addEventListener('scroll', this.handleScroll)


  },
  created() {
    window.addEventListener("beforeunload", this.preventNav)
  },
  beforeDestroy() {
    window.addEventListener("beforeunload", this.preventNav)
  },
  destroyed: function () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    llamar() {
      window.location = 'tel:0034961111020';
    },
    handleScroll: function () {
      var scrollY = window.scrollY
      var headerHeight = document.getElementById('header').clientHeight;
      var configuradorHeight = document.getElementById('configurador').clientHeight;
      if (scrollY > this.scrollYPosition) {
        this.scrollDirection = 'down';
        this.fijarBotonesFooter = false;
        if (scrollY > headerHeight) {
          this.fijarPuente = true;
          document.getElementsByTagName("BODY")[0].style.paddingTop = configuradorHeight + "px";
        }
      } else {
        this.scrollDirection = 'up';
        if (window.innerHeight)
          this.fijarBotonesFooter = true;
        if (scrollY <= headerHeight) {
          this.fijarPuente = false;
          document.getElementsByTagName("BODY")[0].style.paddingTop = "0px";
        }
      }
      this.scrollYPosition = scrollY;
    },
    preventNav(event) {
      //if (this.isPrevenirSalidaModalActive!==true){
      // Cancel the event
      event.preventDefault()
      // Chrome requires returnValue to be set
      this.isPrevenirSalidaModalActive = true;
      event.returnValue = ''
      //}
    },
    visibilityChanged(isVisible, entry) {
      this.isVisible = isVisible
      if (entry.target.nodeName == 'FOOTER' && this.isVisible && this.fijarBotonesFooter === true) {
        this.fijarBotonesFooter = false;
      }
      console.log(this.isVisible)
      console.log(entry.target.nodeName)
      console.log(entry)
      console.log(this)
    },
    cambiaModalSelPuentes(val){
      this.$store.commit('setIsMenuModalActive',val)
    }
  },
  watch: {

    skuactivo: function (newSKU, oldSKU) {
      console.log('Ha cambiado de '+ oldSKU+' a ' + newSKU)


    }
  }
}
</script>

<style scoped>

</style>
